import { createMockCoordinatePolygon } from '@indutrust/shared-model';
import type { MapIndustrialArea } from '../map-industrial-area.model';

/** Canonical default fixture for {@link MapIndustrialArea}. */
export const MOCK_MAP_INDUSTRIAL_AREA: MapIndustrialArea = {
  id: 1,
  name: 'Mock Industrial Area',
  region_id: 1,
  status: 'published',
  coordinates: createMockCoordinatePolygon(),
  freezone: false,
  website: 'https://example.com',
};

/** Returns a {@link MapIndustrialArea} merged with the supplied overrides. */
export function createMockMapIndustrialArea(
  overrides: Partial<MapIndustrialArea> = {}
): MapIndustrialArea {
  return { ...MOCK_MAP_INDUSTRIAL_AREA, ...overrides };
}

/**
 * Returns a list of unique {@link MapIndustrialArea} fixtures.
 * @param count - Number of fixtures to create. Defaults to `3`.
 * @param overrideAt - Optional callback returning per-index overrides.
 */
export function createMockMapIndustrialAreaList(
  count = 3,
  overrideAt?: (index: number) => Partial<MapIndustrialArea>
): MapIndustrialArea[] {
  return Array.from({ length: count }, (_, index) =>
    createMockMapIndustrialArea({
      id: index + 1,
      name: `Mock Industrial Area ${index + 1}`,
      ...overrideAt?.(index),
    })
  );
}
